import { useEffect } from 'react';
import { setIdpBaseUrl } from '@digiwedge/idp-client';
import { useRehydrateTokens } from '@digiwedge/hooks-auth-web';

/**
 * Initialize IDP client base URL and rehydrate tokens from storage.
 */
export function useAuthBootstrap() {
  useEffect(() => {
    try {
      const im = (import.meta as unknown as { env?: { VITE_IDP_BASE_URL?: string } }) || {};
      const raw = (im.env?.VITE_IDP_BASE_URL || '').trim();
      const base = raw || window.location.origin;
      setIdpBaseUrl(base);
    } catch {
      /* noop */
    }
  }, []);
  useRehydrateTokens();
}
